export default {"src":"/_next/static/media/scorecard.ab690742.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};